import { getToken, instance } from './config';

const getAssistantInstanceList = (projectId, params = {}) =>
  instance.get(`/projects/${projectId}/assistant-instance-sets`, {
    headers: { Authorization: `Bearer ${getToken()}` },
    params: { ...params, size: 1000 },
  });

const getAssistantInstance = (projectId, assistantId) =>
  instance.get(
    `/projects/${projectId}/assistant-instance-sets/${assistantId}`,
    {
      headers: { Authorization: `Bearer ${getToken()}` },
    }
  );

const updateAssistantInstance = (projectId, assistantId, data) =>
  instance.put(
    `projects/${projectId}/assistant-instance-sets/${assistantId}`,
    data,
    {
      headers: { Authorization: `Bearer ${getToken()}` },
    }
  );

const deleteAssistantInstance = (projectId, assistantId) =>
  instance.delete(
    `projects/${projectId}/assistant-instance-sets/${assistantId}`,
    {
      headers: { Authorization: `Bearer ${getToken()}` },
    }
  );

export const assistantApis = {
  getAssistantInstanceList,
  getAssistantInstance,
  updateAssistantInstance,
  deleteAssistantInstance,
};
